export const getSubcategoryImageUrl = (item) => {
    const objectPath = item?.imagePath || (item?.image ? `subcategories/${item.image}` : '')
    return objectPath ? `https://storage.googleapis.com/canvasexpress/${objectPath}` : ''
}

export const getUploadedSubcategoryMedia = (data) => {
    if (!data?.success || !data.fileName || !data.path) {
        throw new Error('Incomplete subcategory upload response')
    }
    return { image: data.fileName, imagePath: data.path }
}
